import { useState, useEffect, useRef } from 'react';
import AccountForm from '../../shared/UserAccountForm';
import { useLocalization } from '../../custom-hooks/useLocalization';
import { withLocalization } from '../../shared/Context/LocalizationContext';
import TextInput from '../../shared/FormComponents/TextInput';
import { withServerStyles } from '../../shared/ServerStylesConditionalWrapper';
import { compose } from '../../utils/compose';

const ResetPasswordRequest = (props) => {
  const { resourceStrings } = useLocalization();
  const [state, setState] = useState({});
  const recaptchaRef = useRef(null);
  const hiddenSubmitRef = useRef(null);

  const handleInput = (event) => setState({ ...state, [event.target.name]: event.target.value });

  useEffect(() => {
    if (!state.email && props.email) setState({ ...state, email: props.email });
  }, [props]);

  const getRecaptchaToken = async (e) => {
    e.preventDefault();
    try {
      const token = await new Promise((resolve, reject) =>
        window.grecaptcha.enterprise.ready(() => {
          window.grecaptcha.enterprise
            .execute(props.recaptchaSiteKey, {
              action: 'Reset'
            })
            .then(resolve)
            .catch(reject);
        })
      );
      recaptchaRef.current.value = token;
    } catch (err) {
      console.log('error', err);
    } finally {
      hiddenSubmitRef.current.closest('form').submit();
    }
  };

  const handleEnterKeySubmit = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      getRecaptchaToken(e);
    }
  };

  useEffect(() => {
    hiddenSubmitRef.current
      .closest('form')
      .addEventListener('keydown', handleEnterKeySubmit, { once: true });
  });

  return (
    <AccountForm
      heading={props.meta.pageTitle}
      useDefaultSubmit={false}
      errorMessage={props.errorMessage}
      message={props.message}
    >
      <div className="form-field">
        {!props.dateReset ? (
          <TextInput
            id="email"
            name="email"
            label={resourceStrings['bdO.Login.EmailLabel']}
            type="email"
            errorMessages={{
              patternMismatch: resourceStrings['bdO.PasswordPolicy.error.InvalidEmail'],
              typeMismatch: resourceStrings['bdO.PasswordPolicy.error.InvalidEmail']
            }}
            onInput={handleInput}
            value={state.email}
            additionalAriaLabel="password-strength"
            required
          />
        ) : (
          <>
            <input type="hidden" name="email" value={state.email} />
            <p className="explanation-text">{props.explanationText}</p>
          </>
        )}
      </div>
      <div className="form-field">
        <input hidden id="GToken" name="GToken" type="text" ref={recaptchaRef} />
        <button
          data-sitekey="test"
          className="btn btn-primary submit"
          type="submit"
          onClick={getRecaptchaToken}
        >
          {props?.submitButtonText}
        </button>
      </div>
      <button
        ref={hiddenSubmitRef}
        className="hidden btn btn-primary submit"
        type="submit"
      ></button>
    </AccountForm>
  );
};

export default compose(withLocalization, withServerStyles)(ResetPasswordRequest);
